var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBronce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9907 9.39966L19.6027 23H5.38804L1 9.39966L12.5 1L24 9.39966H23.9907ZM10.5942 10.4099L6.08529 10.9524L9.4228 14.0952L8.53961 18.6412L12.5093 16.3776L16.479 18.6412L15.5958 14.0952L18.9333 10.9524L14.4244 10.4099L12.5186 6.20068L10.6128 10.4099H10.5942Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronce);
export default __webpack_public_path__ + "static/media/bronce.2dd58f249e07c82b327d6ef035ed3292.svg";
export { ForwardRef as ReactComponent };